import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { Language } from '../../../../../shared/enum/language';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { SessionTokenService } from '../../../../../session/service/session-token';

// @deprecated -> replaced with  admin/customer/campaign
@Component({
  selector: 'admin-campaign-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminCampaignListComponent extends AbstractListComponent implements OnInit {

  enabling: any = { fs: false, ai: false };
  status: string = 'live';
  languages: any = Language;

  getResourceUrl(): string {
    return 'admin/campaign';
  }

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              private sessionToken: SessionTokenService,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route);
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Campaigns',
      url: '/admin/campaign'
    });

    this.parameters.limit = 100;
    this.parameters.conditions.status = this.status;
    super.ngOnInit();
  }

  setStatus(status: string) {
    this.status = status;
    this.parameters.conditions.status = status;
    this.load();
  }

  edit(campaign) {
    this.httpClient.put(`/admin/campaign/${campaign.uuid}`, {})
      .subscribe(
        (sessionData: any) => {
          this.sessionToken.storeAdminToken(this.sessionToken.getToken());
          this.sessionToken.persist(sessionData);

          this.router.navigate([ `/campaign/${campaign.uuid}` ]);
        }
      );
  }

  toggleFacialRecognition(campaign: any) {
    this.enabling.fs = true;
    this.httpClient.put(`/admin/campaign/${campaign.uuid}/facial-recognition`, {
      isActive: campaign.facialRecognitionStatus < 2
    })
      .subscribe((response: any) => {
        this.load();
        campaign.facialRecognitionStatus = response.facialRecognitionStatus;
      }, (error: any) => {
        this.toastrService.error('Could not enable facial recognition');
      }).add(() => {
      this.enabling.fs = false;
    });
  }

  toggleAiBackgroundRemoval(campaign: any) {
    this.enabling.ai = true;
    this.httpClient.put(`/admin/campaign/${campaign.uuid}/ai-background-removal`, {
      isActive: campaign.aiBackgroundRemovalStatus < 2
    })
      .subscribe((response: any) => {
        this.load();
        campaign.aiBackgroundRemovalStatus = response.aiBackgroundRemovalStatus;
      }, (error: any) => {
        this.toastrService.error('Could not enable AI background removal');
      }).add(() => {
      this.enabling.ai = false;
    });
  }

  onStatusChange(model) {
    this.httpClient.put(`/admin/campaign/${model.uuid}/status`, {
      isActive: model.status === 'live'
    }).subscribe((response: any) => {
      this.load();
    }, (error: any) => {
      this.toastrService.error('Could not change campaign status');
    });
  }
}
